import { useEffect, useState } from 'react'
import { formatClock } from '@/lib/actModes'
import { cn } from '@/lib/utils'

interface ActTimerDisplayProps {
  startedAt: number | null
  frozenSeconds?: number | null
  /** Hidden until he stops, so the clock can't drag his answer around. */
  hidden?: boolean
}

export default function ActTimerDisplay({ startedAt, frozenSeconds, hidden }: ActTimerDisplayProps) {
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    if (startedAt == null || frozenSeconds != null) return
    setElapsed(Math.floor((Date.now() - startedAt) / 1000))
    const id = setInterval(() => {
      setElapsed(Math.floor((Date.now() - startedAt) / 1000))
    }, 250)
    return () => clearInterval(id)
  }, [startedAt, frozenSeconds])

  const seconds = frozenSeconds != null ? frozenSeconds : elapsed

  return (
    <div className="text-center">
      <div
        className={cn(
          'font-mono font-bold tabular-nums tracking-tight',
          hidden ? 'text-5xl text-muted-foreground' : 'text-6xl'
        )}
        aria-live="off"
      >
        {hidden ? '· · ·' : formatClock(seconds)}
      </div>
      <p className="text-xs text-muted-foreground mt-1">
        {hidden ? 'Clock is running — no peeking' : frozenSeconds != null ? 'Final time' : 'Running'}
      </p>
    </div>
  )
}
